import Country from '~/Api/Country/Country';

import mapPriceTime, { RawPriceTime } from './mapPriceTime';
import TimeToPrice, { Status } from './TimeToPrice';

export interface RawTimeToPrice {
	country: { alpha2: string; name: string };
	minDays: number | null;
	status: string;
	times: RawPriceTime[];
}

export default function mapTimeToPrice(timeToPrice: RawTimeToPrice): TimeToPrice {
	const country = new Country(timeToPrice.country.alpha2, timeToPrice.country.name);

	return new TimeToPrice(
		country,
		timeToPrice.minDays,
		timeToPrice.status as Status,
		timeToPrice.times.map((time) => mapPriceTime(time, country))
	);
}
